import { render, staticRenderFns } from "./VideoChunckGenerator.vue?vue&type=template&id=6b72e52e&scoped=true"
import script from "./VideoChunckGenerator.vue?vue&type=script&lang=ts"
export * from "./VideoChunckGenerator.vue?vue&type=script&lang=ts"
import style0 from "./VideoChunckGenerator.vue?vue&type=style&index=0&id=6b72e52e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b72e52e",
  null
  
)

export default component.exports